// MPEG-TS identifiers for the guest uplink (participant-loop-contracts §2.2):
// H.264 on PID 0x100, AAC/ADTS on PID 0x101, one program, PMT on 0x1000.
// The PMT PID and stream types match the rift demo muxer at the pin and what
// JBS rift_ingress's demuxer discovers (it walks PAT → PMT, so it follows
// these PIDs rather than assuming its own egress PIDs 0x1011/0x1101).
export const TS_PACKET_LEN = 188;
export const TS_PAYLOAD_LEN = TS_PACKET_LEN - 4;
export const SYNC_BYTE = 0x47;
export const PID_PAT = 0x0000;
export const PID_PMT = 0x1000;
export const PID_VIDEO = 0x0100;
export const PID_AUDIO = 0x0101;
export const PID_NULL = 0x1fff;
export const STREAM_TYPE_AAC_ADTS = 0x0f;
export const STREAM_TYPE_H264 = 0x1b;
export const STREAM_TYPE_HEVC = 0x24;
export const STREAM_ID_VIDEO = 0xe0;
export const STREAM_ID_AUDIO = 0xc0;
export const PROGRAM_NUMBER = 1;
export const TRANSPORT_STREAM_ID = 1;
/** 90 kHz PTS/DTS/PCR-base clock. */
export const TS_CLOCK_HZ = 90_000;
/** PTS/DTS/PCR base are 33-bit. */
export const PTS_WRAP = 2 ** 33;
//# sourceMappingURL=constants.js.map